module.exports = __webpack_public_path__ + "static/media/swan-3376622_640-min.8e076dd9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/swan-3376622_640-min.jpg
// module id = 136
// module chunks = 0